/*
* Thème: STACK
*/

window.VideoLoop_PluginInit = function() {
	$('.video-loop').each(function() {
		$(this).VideoLoop()
	})
}

/* End: STACK */
